/// <amd-module name="Wit/SprintsHub/Common/Constants" />

export namespace SprintsTabs {
    export const Taskboard = "taskboard";
    export const SprintBacklog = "backlog";
    export const Capacity = "capacity";
    export const Analytics = "analytics";
}

export namespace RightPaneViews {
    export const Planning = "Planning";
    export const WorkDetails = "Work Details";
    export const Contribution = "contribution";
    export const Off = "Off";
}

export namespace WorkDetailsSectionType {
    export const ACTIVITY = "ACTIVITY";
    export const ASSIGNED_TO = "ASSIGNED_TO";
}

// Map previous right pane ids in NWP to OWP ones
export const RightPaneCompatMap: { [name: string]: string } = {
    ["off"]: RightPaneViews.Off,
    ["planning"]: RightPaneViews.Planning,
    ["workdetails"]: RightPaneViews.WorkDetails,
    ["work-details"]: RightPaneViews.WorkDetails
};

export namespace DataProviders {
    export const AllDirectoryDataProvider = "ms.vss-work-web.sprints-directory-all-data-provider";
    export const DirectoryDataProvider = "ms.vss-work-web.sprints-directory-data-provider";
}

export namespace SettingsConstants {
    export const RightPane = "Agile/RightPanel";
    export const ViewOptionsBubbleSetting = "HasUserSeenViewOptionsLearningBubble";
    export const SprintsHub = "Agile/SprintsHub";
    export const IterationPickerBubbleSetting = "HasUserSeenIterationPickerLearningBubble";
    export const Taskboard = "Agile/Taskboard";
    export const ColumnOptionsBubbleSetting = "ColumnOptions";
    export const WebTeam = "WebTeam";
    export const Project = "Project";

    export const ContentPivotSetting = "Agile/SprintsHub/Navigation/ContentPivot";
    export const PivotSettings = "Agile/SprintsHub/Navigation/PivotSettings";

    export const ReorderMessageClosed = "ReorderMessageClosed";
}

export const enum TaskboardGroupBy {
    Loading = "loading",
    Parents = "requirements",
    AssignedTo = "people"
}

// Map previous group by ids in NWP to OWP ones
export const GroupByCompatMap: { [name: string]: TaskboardGroupBy } = {
    ["parents"]: TaskboardGroupBy.Parents,
    ["assigned-to"]: TaskboardGroupBy.AssignedTo
};

export const enum WorkItemSignalREventType {
    ItemUpdated = "Updated",
    ItemAdded = "Added",
    ItemDeleted = "Deleted",
    ItemRestored = "Restored",
    ItemCreated = "Created",
    ItemRemoved = "Removed"
}

export const enum ParentChangeType {
    Added = "Added",
    Removed = "Removed",
    Unchanged = "Unchanged"
}

export const unassignedId = "Unassigned";
export const unparentedId = 0;
